<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-6">
        <div class="content new-item">
          <h2 class="block-title" style="margin-bottom: 30px">Add assets</h2>

          <el-form ref="assets_form" :model="form" :rules="ruleValidate" label-position="top" @submit.native.prevent>
            <el-form-item label="Scope" prop="scope">
              <el-select v-model="form.scope" filterable remote :remote-method="loadScopes" default-first-option
                placeholder="Scope">
                <el-option v-for="item in scopes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-button type="button" class="btn btn-primary" @click="newScopeModalVisible = true">
                +
              </el-button>
              <el-dialog title="New scope" :visible.sync="newScopeModalVisible" class="modalSave">
                <el-form ref="newScopeForm" :model="newScopeForm">
                  <el-form-item label="Scope name" prop="name" :rules="{
                    required: true,
                    message: 'Name can not be empty',
                    trigger: 'blur',
                  }">
                    <el-input v-model="newScopeForm.name" autocomplete="off"></el-input>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <button class="btn btn-primary" @click="newScopeModalVisible = false">
                    Cancel
                  </button>
                  <button class="btn btn-success" @click="addScope">
                    <i class="vik vik-save"></i>Save
                  </button>
                </span>
              </el-dialog>
            </el-form-item>
            <el-form-item label="Assets" prop="hosts">
              <el-input v-model="form.hosts" type="textarea" rows="30" placeholder="target1.com
  target2.com" />
            </el-form-item>
            <el-form-item>
              <el-button type="button" class="btn btn-success" @click="submitForm('assets_form')" :loading="loading"
                icon="vik vik-save">
                Add assets
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from "@/bus.js";
import * as utils from "@/utils.js";
import { addScope, getScopes, addAssets } from "@/api.js";

export default {
  data() {
    return {
      loading: false,
      newScopeModalVisible: false,
      form: {
        scope: "",
        hosts: "",
      },
      newScopeForm: {
        name: "",
      },
      ruleValidate: {
        hosts: [
          {
            required: true,
            message: "Assets are required",
            trigger: "blur",
          },
        ],
      },
      rules: {},
      scopes: [],
    };
  },
  mounted() {
    this.loadScopes();
  },
  methods: {
    addScope() {
      let that = this;
      this.$refs["newScopeForm"].validate((valid) => {
        if (valid) {
          that.loading = true;
          addScope(that.newScopeForm).then((data) => {
            that.scopes.push({
              label: that.newScopeForm.name.trim(),
              value: data.id,
            });
            that.form.scope = data.id;
            that.newScopeModalVisible = false;
            that.loading = false;
            bus.$emit("refresh-scopes");
          });
        } else {
          return false;
        }
      });
    },
    loadScopes(q) {
      getScopes(
        utils.objectToString({
          q: q,
        })
      ).then((data) => {
        this.scopes = [];
        for (const scope of data.Records) {
          this.scopes.push({ label: scope.name, value: scope.id });
        }
      });
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true;
          let hosts_array = this.form.hosts.split("\n");
          let new_assets = [];
          console.log('f',that.form)
          for (let h of hosts_array){
            new_assets.push({
              scope_id: that.form.scope,
              host: h
            })
          }
          addAssets(new_assets)
            .then(() => {
              this.loading = false;
              this.$notify({
                title: "Success",
                message: "The records were added",
                type: "success",
              });
              bus.$emit("refresh-scopes");
              this.form.hosts = "";
            })
            .catch((err) => {
              this.$notify({
                title: "Error",
                message: err,
                type: "error",
              });
            });
        }
        /*else {
          this.$Message.error("Invalid records");
          return false;
        }
        */
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success("Success!");
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
  },
  computed: {
    listsComputed() {
      var items = [];
      for (var i in this.lists) {
        items.push({ label: this.lists[i].list_name, value: this.lists[i].id });
      }
      return items;
    },
  },
};
</script>

<style scoped>
.el-row {
  margin: 20px;
  padding: 20px;
}

.el-input {
  margin-top: 5px;
}

.mrg {
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/AddAssets.vue